<div class="maintenance">
    <div class="maintenance__container">

        <div class="maintenance__logo">
            <img src="assets/logo.svg" alt="Logo">
        </div>

        <div class="maintenance__illustration">
            <img src="assets/Maintenace-screen.svg" alt="Maintenace-screen">
        </div>

        <div class="maintenance__content-text-wrapper">
            <h1 class="maintenance__content-text-wrapper__title">Down for maintenance.</h1>

            <p class="maintenance__content-text-wrapper__description">
                Our site is currently down for maintenance. We're working hard to get
                things back up and running. In the meantime, feel free to reach out to us if
                you need assistance. We're here to help and we appreciate your patience!
            </p>
        </div>

        <div class="maintenance__actions">
            <a class="maintenance__btn maintenance__btn--primary" href='https://fusionsuite.io/contact-us' target="_blank" rel="noopener noreferrer">
                <svg class="maintenance__btn-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_34203_6)">
                        <path d="M5.7 18.2998H5C3.0673 18.2998 1.5 16.7325 1.5 14.7998C1.5 12.8671 3.0673 11.2998 5 11.2998H5.7V18.2998Z" stroke="white"
                            style="stroke:white;stroke-opacity:1;" stroke-width="1.86667" stroke-miterlimit="10" stroke-linejoin="round" />
                        <path d="M18.9998 18.2998H18.2998V11.2998H18.9998C20.9325 11.2998 22.4998 12.8671 22.4998 14.7998C22.4998 16.7325 20.9325 18.2998 18.9998 18.2998Z"
                            stroke="white" style="stroke:white;stroke-opacity:1;" stroke-width="1.86667" stroke-miterlimit="10" stroke-linejoin="round" />
                        <path d="M4.2998 11.3V9.2C4.2998 4.9475 7.7473 1.5 11.9998 1.5C16.2523 1.5 19.6998 4.9475 19.6998 9.2V11.3" stroke="white"
                            style="stroke:white;stroke-opacity:1;" stroke-width="1.86667" stroke-miterlimit="10" stroke-linejoin="round" />
                        <path
                            d="M16.2002 21.5665C15.6847 21.5665 15.2669 21.9843 15.2669 22.4998C15.2669 23.0153 15.6847 23.4331 16.2002 23.4331V21.5665ZM18.7669 18.2998V21.0998H20.6335V18.2998H18.7669ZM18.7669 21.0998C18.7669 21.3578 18.5582 21.5665 18.3002 21.5665V23.4331C19.5892 23.4331 20.6335 22.3888 20.6335 21.0998H18.7669ZM18.3002 21.5665H16.2002V23.4331H18.3002V21.5665Z"
                            fill="white" style="fill:white;fill-opacity:1;" />
                        <path d="M11.8423 22.5L13.2197 22.5" stroke="white" style="stroke:white;stroke-opacity:1;" stroke-width="1.86667" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_34203_6">
                            <rect width="24" height="24" fill="white" style="fill:white;fill-opacity:1;" />
                        </clipPath>
                    </defs>
                </svg>
                Contact Support
            </a>

            <a class="maintenance__btn maintenance__btn--secondary" href='https://fusionsuite.io/' target="_blank" rel="noopener noreferrer">
                <svg class="maintenance__btn-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
                        stroke="#303030" style="stroke:#303030;stroke:color(display-p3 0.1882 0.1882 0.1882);stroke-opacity:1;" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M15 3H21V9" stroke="#303030" style="stroke:#303030;stroke:color(display-p3 0.1882 0.1882 0.1882);stroke-opacity:1;" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M10.0005 14L21.0005 3" stroke="#303030" style="stroke:#303030;stroke:color(display-p3 0.1882 0.1882 0.1882);stroke-opacity:1;" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Visit website
            </a>
        </div>

    </div>
</div>